import { localizePath, stripLocalePrefix } from "@/lib/localeRoutes";

export const ISTANBUL_DESTINATIONS = [
  { slug: "taksim" },
  { slug: "sultanahmet" },
  { slug: "sisli" },
  { slug: "besiktas" },
  { slug: "kadikoy" },
] as const;

export type IstanbulDestinationSlug =
  (typeof ISTANBUL_DESTINATIONS)[number]["slug"];

const DESTINATION_SLUGS = new Set<string>(
  ISTANBUL_DESTINATIONS.map(({ slug }) => slug),
);

export function istanbulHubPath(locale: string): string {
  return localizePath("/locations/istanbul", locale);
}

export function istanbulDestinationPath(
  slug: IstanbulDestinationSlug,
  locale: string,
): string {
  return localizePath(`/locations/istanbul/${slug}`, locale);
}

export function resolveIstanbulDestination(
  pathname: string,
): IstanbulDestinationSlug | null {
  const segments = stripLocalePrefix(pathname).split("/").filter(Boolean);

  if (
    segments.length !== 3 ||
    segments[0] !== "locations" ||
    segments[1] !== "istanbul" ||
    !DESTINATION_SLUGS.has(segments[2])
  ) {
    return null;
  }

  return segments[2] as IstanbulDestinationSlug;
}
